import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import DatePick from 'vue-date-pick'
import Autocomplete from 'vuejs-auto-complete'
import VueUploadComponent from 'vue-upload-component'
import { VueEditor } from 'vue2-editor'
import {Cropper} from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
    name: 'TripForm',
    computed,
    data,
    methods,
    mounted,
    watch,
    components: {
      Cropper,
        DatePick,
        Autocomplete,
        VueEditor,
        VueUploadComponent,
    }
}
